<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div class="text-center">
      <p>确定删除开户行</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="deleteAccountBank">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAccountBank } from '@/api/goods/accountBankApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAccountBank',
  data() {
    return {
      dialogVisible: false,
      deleteAccountBankInfo: {}
    }
  },
  methods: {
    open(accountBank) {
      this.dialogVisible = true
      this.deleteAccountBankInfo = { ...accountBank }
      this.deleteAccountBankInfo.shopId = getShopId()
    },
    deleteAccountBank() {
      deleteAccountBank(this.deleteAccountBankInfo)
        .then(response => {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        })
        .catch(error => {
          this.$message.error(error.message || '删除失败')
        })
    },
    handleClose() {
      this.deleteAccountBankInfo = {}
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
  margin: 20px 0;
}
</style>